import { AppModule } from 'app/module';
import { BsCompanyLocationItem } from 'module/bsCompanyLocationItem/main';
import { smoothScrollTo, smoothScrollToElement } from 'util/scroll';
import { mediaQueries } from 'util/mediaQueries';

import Template from './template.hbs';
import './styles.scss';

export class BsCompanyLocationList extends AppModule {
    setTemplate() {
        this.template = Template;
        if (module.hot) {
            module.hot.accept('./template.hbs', () => {
                this.template = Template;
                this.render();
            });
        }
    }

    domBindings() {
        return {
            locations: ['.m-bsCompanyLocationItem'],
            toggleShowMore: '.m-bsCompanyLocationList__toggleShowMore',
            locationsUrlItem: '.m-bsCompanyLocationList__link .m-bsCompanyLocationItem__link',
        };
    }

    getPropsFromDom() {
        return {
            showMore: false,
            hasMore: this.dom.toggleShowMore !== null,
            locationsUrl: this.dom.locationsUrlItem ? this.dom.locationsUrlItem.href : '',
        };
    }

    subs() {
        if (this.dom.locations) {
            this.locations = [];
            const locationProps = {};

            for (let i = 0; i < this.dom.locations.length; i += 1) {
                this.locations[i] = new BsCompanyLocationItem(this.dom.locations[i]);
                locationProps[i] = this.locations[i].getPropsFromDom();
            }
            this.props.items = locationProps;
        }
    }

    domEvents() {
        if (this.dom.toggleShowMore) {
            this.dom.toggleShowMore.addEventListener('click', (e) => {
                this.toggleCompanyLocationList(e);
            });
        }
    }

    toggleCompanyLocationList(e) {
        if (e) e.preventDefault();
        const stickyNavBarHeight = 70;

        if (this.props.showMore && !mediaQueries.isDesktop()) {
            smoothScrollTo(this.dom.el.offsetTop - stickyNavBarHeight, 500);
        } else if (!this.props.showMore && !mediaQueries.isDesktop()) {
            const lastElement = this.dom.el.querySelector('.m-bsCompanyLocationList__item:nth-of-type(7)');
            smoothScrollToElement(lastElement, 500);
        }

        this.updateProps({ showMore: !this.props.showMore }, true);
    }
}
